import { makeFragmentData } from '@packages/gql/generated/shopping';
import {
  RecommendationsFragmentFragmentDoc,
  type RecommendationsFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';

export const recommendationsDataMock: RecommendationsFragmentFragment = {
  hasSeries: false,
  defaultCategory: '35092',
  promotion: '79',
  orderNumber: '96692022',
  brand: {
    name: 'Nike Sportswear',
  },
  availability: {
    state: 'AVAILABLE',
  },
  price: {
    value: 13999,
  },
};

export function getRecommendationsFragmentedData(data?: RecommendationsFragmentFragment) {
  return makeFragmentData(data || recommendationsDataMock, RecommendationsFragmentFragmentDoc);
}
